import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { RadioSwatch as CoreRadioSwatch } from '@vds-core/inputs';
import { colors } from '@vds/theme';
import { BodyConfig, TypographyConfig } from '@vds/typography';
var typescale = TypographyConfig.getTypescale();

var RadioSwatch = function RadioSwatch(props) {
  return /*#__PURE__*/React.createElement(CoreRadioSwatch, _extends({}, props, {
    colorConfig: colors,
    bodyConfig: BodyConfig,
    typescale: typescale,
    typographyConfig: TypographyConfig,
    focusSize: undefined,
    focusState: false,
    selectedStateDoubleBorder: false,
    labelMargin: undefined,
    labelMaxWidth: undefined,
    labelMinWidth: undefined,
    swatchMargin: undefined,
    size: undefined,
    disabledState: true,
    outOfStock: false
  }));
};

export default RadioSwatch;